import { FETCH_APP_STATUS_TYPES } from "./initAppActionTypes";

export const fetchAppStatusTypes = () => ({
    type: FETCH_APP_STATUS_TYPES,
});